import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'tooltipText',
  props: {
  text: {
    default: '',
  },
  maxLength: {
    type: Number,
    default: 24,
  },
},
  setup(__props) {

const props = __props;

const needTooltip = computed(
  () => props.text.toString().length > props.maxLength
);
const computedText = computed(() =>
  needTooltip.value
    ? `${props.text.toString().slice(0, props.maxLength)}...`
    : props.text.toString()
);

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    (needTooltip.value)
      ? (_openBlock(), _createBlock(_component_v_tooltip, {
          key: 0,
          location: "bottom",
          "max-width": "600",
          "open-on-click": "",
          "content-class": "whitespace"
        }, {
          activator: _withCtx(({ props }) => [
            _createElementVNode("div", _mergeProps(props, { class: "pointerCursor" }), [
              _createElementVNode("span", null, _toDisplayString(computedText.value), 1)
            ], 16)
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(__props.text), 1)
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(computedText.value), 1))
  ]))
}
}

})